//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "index",

  data: function () {
    return {
      selectedProducts: [],
      termDeliveryMessage: "",
      changedProductCart: null
    }
  },

  computed: {
    products: function () {
      return this.$store.state?.cart?.items
    },
    isLoadProducts: function () {
      return Boolean(
        this.$store.state.loadings?.carts ||
        this.$store.state?.cart?.loading?.cart ||
        this.$store.state?.cart?.loading?.putToCart ||
        this.$store.state?.cart?.loading?.removeCartItem ||
        this.$store.state?.cart?.loading?.updateCartItem
      )
    },

    isCheckedSelectedAll: function () {
      return (this.selectedProducts.length === this.products.length)
    }
  },

  components: {
    CartProduct: () => import("~/components/cart-new/CartProduct"),
    CartInformationStep1: () => import("~/components/cart-new/CartInformationStep1"),
    DialogChangeOptions: () => import("~/components/cart/DialogChangeOptions")
  },

  watch: {
    products: function () {
      this.selectedProducts = [...this.selectedProducts].filter((t) => Boolean(this.products.find((p) => p.id === t)));
      this.updateCheckoutData();
      this.initSelectedProducts();
      this.changeCompoundProducts();
      this.$store.dispatch("cart-new/getBonusesAccrued");
    }
  },

  mounted: function () {
    this.$yandexMetrika.reachGoal('BUY');
    this.updateCheckoutData();
    this.initSelectedProducts();

    this.$store.dispatch("cart-new/getBonusesAccrued");
  },

  methods: {
    initSelectedProducts: function () {
      this.selectedProducts = [...this.products].map((t) => t.id)
    },

    updateCheckoutData: function () {
      this.$store.dispatch("cart-new/getCheckoutData");
      (async () => {
        await this.getMessageDeliveryTerm();
      })();
    },
    getMessageDeliveryTerm: async function () {
      const res = await this.$api.agent.transport.get('/delivery-term/cart-message').then((res) => {
        return res.data?.message
      }).catch(() => {
        return ""
      });
      this.termDeliveryMessage = res;
    },

    removeSelectedProducts: async function () {
      this.$store.commit("local-settings/setShowDialogLoading", true);

      await Promise.all(this.selectedProducts.map(async (itemId) => {
        await this.$api.agent.transport.delete(`/cart/${itemId}`);
      }));
      await this.$store.dispatch("cart/getCart");

      this.$store.commit("local-settings/setShowDialogLoading", false);
    },
    changeSelectedProducts: function (itemId) {
      let selectedProducts = [...this.selectedProducts];

      const index = selectedProducts.findIndex((t) => itemId === t);
      if (index > -1) {
        selectedProducts.splice(index, 1)
      } else {
        selectedProducts.push(itemId)
      }

      this.selectedProducts = selectedProducts;
    },
    changeCheckedSelectedAll: function () {
      let selectedProducts = [];
      if (!this.isCheckedSelectedAll) {
        selectedProducts = this.products.map((t) => t.id);
      }
      this.selectedProducts = selectedProducts;
    },

    changeModification: function (cartItem) {
      this.changedProductCart = cartItem;
    },
    closeChangeModification: function () {
      this.changedProductCart = null;
    },

    changeCompoundProducts: function () {
      this.$store.commit("cart-new/resetDeliveryInfo");
      this.$store.commit("cart-new/resetPickupPointsInfo");
    }
  }
}
